import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './PageDelivery.scss';
import './PageDelivery-media.scss';

import Content from '../../components/Content/Content';
import DeliveryBlockInfo from '../../components/DeliveryBlockInfo/DeliveryBlockInfo';
import FormContactsNew from '../../components/FormContactsNew/FormContactsNew';
import { Props } from './interfaces';



const PageDelivery = ({ widthWindow, pageContent }:Props) => {
  return (
    <div className="page-delivery">

      <Content
        noLazy
        padding={{ paddingMain: { top: 20, bottom: 80 }, paddingMob: { top: 0, bottom: 16 } }}
        block={<DeliveryBlockInfo pageContent={pageContent} />}
      />

      <Content
        heightLazy={widthWindow > 720 ? 508 : null}
        padding={{ paddingMain: { top: 80, bottom: 0 }, paddingMob: { top: 40, bottom: 0 } }}
        block={
          <FormContactsNew
            title="Получите коммерческое предложение"
            subTitle="на сервис доставки для ваших покупателей"
            buttonText="Отправить"
            eventMetrika="form_calc"
            sendAmoCRM
          />
        }
      />
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageDelivery));
